import { SanityArrayItem } from 'types';
import { Link } from '../../../../sanity/sanity.types';
import LinkComponent from 'next/link';

type Props = {
  links: SanityArrayItem<Link>[];
};

const UrlColumn = ({ links }: Props) => {
  return (
    <nav>
      <ul className="ml-0 list-none space-y-8">
        {links.map((link) => (
          <li key={link._key}>
            <LinkComponent href={link.href} className="text-sm text-gray-dark">
              {link.title}
            </LinkComponent>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default UrlColumn;
